import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'

// utc MUST be extended before timezone (timezone depends on utc)
// eslint-disable-next-line import/no-named-as-default-member -- extend is a method on dayjs instance, not a named export
dayjs.extend(utc)
// eslint-disable-next-line import/no-named-as-default-member -- extend is a method on dayjs instance, not a named export
dayjs.extend(timezone)
// eslint-disable-next-line import/no-named-as-default-member -- extend is a method on dayjs instance, not a named export
dayjs.extend(relativeTime)
// Import this instead of 'dayjs' directly when you need timezone/utc functionality
// eslint-disable-next-line import/no-default-export -- dayjs uses default export pattern
export default dayjs
